import { render, staticRenderFns } from "./features-customers-modal.vue?vue&type=template&id=54564aad&scoped=true&"
import script from "./features-customers-modal.vue?vue&type=script&lang=js&"
export * from "./features-customers-modal.vue?vue&type=script&lang=js&"
import style0 from "./features-customers-modal.vue?vue&type=style&index=0&id=54564aad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54564aad",
  null
  
)

export default component.exports